import { createContext, PropsWithChildren, useContext, useState } from "react";
import { State } from "./types";

const EmailLogContext = createContext(undefined);

export function useEmailLogContext() {
  return useContext<{
    state: State;
    updateState: (update: Partial<State>) => void;
  }>(EmailLogContext);
}

export default function EmailLogProvider({ children }: PropsWithChildren) {
  const [state, setState] = useState<State>(init);

  const updateState = (update: Partial<State>) => {
    setState(prev => ({ ...prev, ...update }));
  };

  return (
    <EmailLogContext.Provider value={{ state, updateState }}>
      {children}
    </EmailLogContext.Provider>
  );
}

function init(): State {
  return {
    currentTab: "SEARCH",
    status: "IDLE",
    searchCriteria: { dateFrom: 0, dateTo: 0 },
    logs: [],
    hasMore: false,
    page: 0,
    rowsPerPage: 100,
    filtersExpanded: true,
    showReportConfig: false,
    selectedEmail: null,
    reportsData: {
      reports: [],
      total: 0,
      pages: 0,
      pageSize: 0,
      currentPage: 1,
    },
  };
}
